import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWhatsHot, useArticlesByTreatmentCategory } from '../hooks/useWhatsHot';
import { TreatmentCategory } from '../types/article';
import SearchBar from '../components/SearchBar';

// Import local images
import articleImage1 from '../assets/images/whats-hot/article1.png';
import articleImage2 from '../assets/images/whats-hot/article2.png';
import articleImage3 from '../assets/images/whats-hot/article3.png';
import heroImage from '../assets/images/whats-hot/hero-image.png';
import cloutLogo from '../assets/logos/clout-logo.png';

// Icons
const NotificationIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
      stroke="#1f1f1f"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
      stroke="#1f1f1f"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const UserIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
      stroke="#1f1f1f"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
      stroke="#1f1f1f"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CalendarIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.6667 2.66667H3.33333C2.59695 2.66667 2 3.26362 2 4V13.3333C2 14.0697 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0697 14 13.3333V4C14 3.26362 13.403 2.66667 12.6667 2.66667Z"
      stroke="#767472"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6667 1.33334V4.00001"
      stroke="#767472"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33333 1.33334V4.00001"
      stroke="#767472"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 6.66667H14"
      stroke="#767472"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArrowRightIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.75 13.5L11.25 9L6.75 4.5"
      stroke="#1f1f1f"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const FacebookIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17L18 10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z"
      stroke="#1f1f1f"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const InstagramIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="2" width="20" height="20" rx="5" stroke="#1f1f1f" strokeWidth="2" />
    <path
      d="M16 11.37C16.1234 12.2022 15.9813 13.0522 15.5938 13.799C15.2063 14.5458 14.5931 15.1514 13.8416 15.5297C13.0901 15.9079 12.2384 16.0396 11.4078 15.9059C10.5771 15.7723 9.80976 15.3801 9.21484 14.7852C8.61991 14.1902 8.22773 13.4229 8.09408 12.5922C7.96043 11.7616 8.09208 10.9099 8.47034 10.1584C8.84859 9.40685 9.45419 8.79374 10.201 8.40624C10.9478 8.01874 11.7978 7.87658 12.63 8C13.4789 8.12588 14.2649 8.52146 14.8717 9.12831C15.4785 9.73515 15.8741 10.5211 16 11.37Z"
      stroke="#1f1f1f"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 6.5H17.51"
      stroke="#1f1f1f"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

interface ArticleCardProps {
  id?: number;
  image: string;
  date: string;
  title: string;
  description: string;
}

const ArticleCard: React.FC<ArticleCardProps> = ({ id, image, date, title, description }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white flex flex-col">
      <div className="relative aspect-[392/190] overflow-hidden">
        <img src={image || heroImage} alt={title} className="w-full h-full object-cover" />
      </div>
      <div className="p-3 sm:p-4 flex flex-col flex-1">
        <div className="flex items-center gap-1 mb-2">
          <CalendarIcon />
          <span className="font-['Open_Sans'] text-xs sm:text-sm text-[#767472]">{date}</span>
        </div>
        <h3 className="font-['Ovo'] text-lg sm:text-xl lg:text-2xl text-[#333333] uppercase mb-3 sm:mb-4">{title}</h3>
        <p className="font-['Open_Sans'] font-light text-sm sm:text-base text-[#333333] mb-3 sm:mb-4 flex-1 line-clamp-3">
          {description}
        </p>
        <button
          onClick={() => navigate(id ? `/article/${id}` : '/article/1')}
          className="w-full px-4 sm:px-6 py-2.5 sm:py-3 bg-white border border-[#1f1f1f] text-[#1f1f1f] font-['Ovo'] text-base sm:text-lg lg:text-xl uppercase hover:bg-[#1f1f1f] hover:text-white transition-colors min-h-[44px]"
        >
          READ MORE
        </button>
      </div>
    </div>
  );
};

const WhatsHot: React.FC = () => {
  const navigate = useNavigate();
  const [selectedFilter, setSelectedFilter] = useState<TreatmentCategory | null>(
    TreatmentCategory.DERMA_FILLERS
  );
  const { data: whatsHotData, loading, error } = useWhatsHot();
  const { articles: filteredArticles } = useArticlesByTreatmentCategory(selectedFilter);

  // Format date for display
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  };

  // Use hardcoded data as fallback if API fails
  const fallbackPopularArticles = [
    {
      image: articleImage1,
      date: 'Apr 8, 2023',
      title: 'Top 5 Non-Invasive Treatments Trending in 2025',
      description:
        'From skin tightening to bio-fillers, discover the non-surgical treatments gaining traction this year.',
    },
    {
      image: articleImage2,
      date: 'Apr 8, 2023',
      title: 'CLOUT Certified: What It Means & Why It Matters',
      description:
        'From skin tightening to bio-fillers, discover the non-surgical treatments gaining traction this year.',
    },
    {
      image: articleImage3,
      date: 'Apr 8, 2023',
      title: 'How Top Providers Earn Endorsements',
      description:
        'From skin tightening to bio-fillers, discover the non-surgical treatments gaining traction this year.',
    },
  ];

  // Get display articles based on selected filter
  const displayArticles =
    filteredArticles.length > 0
      ? filteredArticles.slice(0, 3).map((article) => ({
          id: article.id,
          image: article.featured_image_url || articleImage1,
          date: formatDate(article.published_at || new Date().toISOString()),
          title: article.title,
          description: article.excerpt || '',
        }))
      : (whatsHotData?.recent_articles || []).slice(0, 3).map((article) => ({
          id: article.id,
          image: article.featured_image_url || articleImage1,
          date: formatDate(article.published_at),
          title: article.title,
          description: article.excerpt,
        }));

  // const handleLogout = () => { // eslint-disable-line @typescript-eslint/no-unused-vars
  //   logout();
  //   navigate('/signin');
  // };

  return (
    <div className="min-h-screen bg-[#fcfaf8]">
      {/* Header */}
      <header className="bg-[#f8f6f2]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between py-3 sm:py-4">
            {/* Logo */}
            <div className="flex items-center">
              <img src={cloutLogo} alt="CLOUT Aesthetics" className="h-10 sm:h-14" />
            </div>

            {/* Search Bar */}
            <div className="hidden md:flex flex-1 max-w-lg mx-8">
              <SearchBar />
            </div>

            {/* Right Icons */}
            <div className="flex items-center space-x-2 sm:space-x-4">
              <button className="p-2 hover:bg-white/50 rounded-full transition-colors min-w-[44px] min-h-[44px] flex items-center justify-center">
                <NotificationIcon />
              </button>
              <button
                onClick={() => navigate('/profile')}
                className="p-2 hover:bg-white/50 rounded-full transition-colors min-w-[44px] min-h-[44px] flex items-center justify-center"
              >
                <UserIcon />
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Navigation */}
      <nav className="bg-white border-t border-b border-[#eaeaea]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-center overflow-x-auto no-scrollbar">
            <button
              onClick={() => navigate('/dashboard')}
              className="px-4 sm:px-8 py-3 text-xs sm:text-sm font-['Ovo'] text-[#1f1f1f] uppercase hover:bg-[#1f1f1f] hover:text-white transition-colors whitespace-nowrap min-h-[44px]"
            >
              HOME
            </button>
            <button
              onClick={() => navigate('/endorsements')}
              className="px-4 sm:px-8 py-3 text-xs sm:text-sm font-['Ovo'] text-[#1f1f1f] uppercase hover:bg-[#1f1f1f] hover:text-white transition-colors whitespace-nowrap min-h-[44px]"
            >
              ENDORSEMENTS
            </button>
            <button className="px-4 sm:px-8 py-3 text-xs sm:text-sm font-['Ovo'] text-white uppercase bg-[#1f1f1f] whitespace-nowrap min-h-[44px]">
              WHAT'S HOT!
            </button>
            <button
              onClick={() => navigate('/dashboard/analytics')}
              className="px-4 sm:px-8 py-3 text-xs sm:text-sm font-['Ovo'] text-[#1f1f1f] uppercase hover:bg-[#1f1f1f] hover:text-white transition-colors whitespace-nowrap min-h-[44px]"
            >
              ANALYTICS
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <div className="relative h-[300px] sm:h-[400px] lg:h-[500px] w-full overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src={heroImage}
            alt="Aesthetic treatment room"
            className="w-full h-full object-cover"
          />
          {/* Gradient overlay for better text readability */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 sm:from-black/50 to-transparent"></div>
        </div>

        {/* Text Content */}
        <div className="relative z-10 h-full flex items-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-16 w-full">
            <div className="max-w-2xl">
              <h1 className="font-['Ovo'] text-2xl sm:text-4xl lg:text-5xl text-white uppercase mb-3 sm:mb-6">
                WHAT'S HOT IN AESTHETICS
              </h1>
              <p className="font-['Open_Sans'] text-base sm:text-xl lg:text-2xl text-white">
                Stay updated with insights, tips, and success stories from the aesthetics industry.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-16 py-8 sm:py-12">
        {/* Popular Articles */}
        <div className="mb-10 sm:mb-16">
          <h2 className="font-['Ovo'] text-2xl sm:text-3xl text-black uppercase mb-6 sm:mb-8">POPULAR ARTICLES</h2>
          {loading ? (
            <div className="text-center py-8">
              <p className="text-[#767472]">Loading articles...</p>
            </div>
          ) : error ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
              {fallbackPopularArticles.map((article, index) => (
                <ArticleCard key={index} {...article} />
              ))}
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
              {(whatsHotData?.popular_articles || []).length > 0
                ? whatsHotData?.popular_articles
                    .slice(0, 3)
                    .map((article) => (
                      <ArticleCard
                        key={article.id}
                        id={article.id}
                        image={article.featured_image_url || articleImage1}
                        date={formatDate(article.published_at)}
                        title={article.title}
                        description={article.excerpt}
                      />
                    ))
                : fallbackPopularArticles.map((article, index) => (
                    <ArticleCard key={index} {...article} />
                  ))}
            </div>
          )}
        </div>

        {/* Filters */}
        <div className="mb-6 sm:mb-8">
          <div className="flex overflow-x-auto no-scrollbar gap-2 sm:gap-3 pb-2 sm:flex-wrap">
            {whatsHotData?.treatment_filters.map((filter) => (
              <button
                key={filter.category}
                onClick={() => setSelectedFilter(filter.category)}
                className={`px-3 sm:px-4 py-2 sm:py-3 font-['Open_Sans'] text-sm sm:text-base transition-all whitespace-nowrap min-h-[44px] flex-shrink-0 ${
                  selectedFilter === filter.category
                    ? 'bg-[#c6a664] text-white font-semibold'
                    : 'bg-white text-[#1f1f1f] border border-[#c6a664]'
                }`}
              >
                {filter.display_name}
                {filter.count > 0 && (
                  <span className="ml-1 text-xs sm:text-sm opacity-75">({filter.count})</span>
                )}
              </button>
            ))}
          </div>
        </div>

        {/* Recent Articles */}
        <div>
          <h2 className="font-['Ovo'] text-2xl sm:text-3xl text-black uppercase mb-6 sm:mb-8">RECENT ARTICLES</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
            {displayArticles.length > 0
              ? displayArticles.map((article, index) => <ArticleCard key={index} {...article} />)
              : fallbackPopularArticles.map((article, index) => (
                  <ArticleCard key={index} {...article} />
                ))}
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#f8f6f2] mt-12 sm:mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-16 py-10 sm:py-16">
          <div className="flex flex-col sm:flex-row justify-between gap-8 sm:gap-12">
            {/* Logo and Social */}
            <div className="w-full sm:w-auto">
              <div className="mb-6 sm:mb-8">
                <img src={cloutLogo} alt="CLOUT Aesthetics" className="h-16 sm:h-24" />
              </div>
              <div className="flex gap-3 sm:gap-4">
                <button className="w-12 sm:w-14 h-12 sm:h-14 bg-white rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors">
                  <FacebookIcon />
                </button>
                <button className="w-12 sm:w-14 h-12 sm:h-14 bg-white rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors">
                  <InstagramIcon />
                </button>
              </div>
            </div>

            {/* Footer Links */}
            <div className="space-y-3 sm:space-y-4">
              <button
                onClick={() => navigate('/search')}
                className="flex items-center gap-2 font-['Ovo'] text-sm sm:text-base lg:text-xl text-[#1f1f1f] uppercase hover:text-[#c6a664] transition-colors min-h-[44px]"
              >
                <ArrowRightIcon /> FIND A PROVIDER
              </button>
              <button
                onClick={() => navigate('/signup')}
                className="flex items-center gap-2 font-['Ovo'] text-sm sm:text-base lg:text-xl text-[#1f1f1f] uppercase hover:text-[#c6a664] transition-colors min-h-[44px]"
              >
                <ArrowRightIcon /> BECOME CLOUT CERTIFIED
              </button>
              <button
                onClick={() => navigate('/endorsements')}
                className="flex items-center gap-2 font-['Ovo'] text-sm sm:text-base lg:text-xl text-[#1f1f1f] uppercase hover:text-[#c6a664] transition-colors min-h-[44px]"
              >
                <ArrowRightIcon /> ENDORSE A PROVIDER
              </button>
              <button
                onClick={() => navigate('/who-we-are')}
                className="flex items-center gap-2 font-['Ovo'] text-sm sm:text-base lg:text-xl text-[#1f1f1f] uppercase hover:text-[#c6a664] transition-colors min-h-[44px]"
              >
                <ArrowRightIcon /> WHO WE ARE
              </button>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default WhatsHot;
